import React from 'react';
import parser from 'html-react-parser';

export default function Modal({ modalData }) {
  const { thumbUrl, details } = modalData;
  const { title, description, youtubeUrl } =    details;
  return (
    <div className="px-modal rounded">
      <div className="single-project-box">
        <div className="row align-items-start">
          <div className="col-lg-7">
            {youtubeUrl ? (
                <iframe
                    width="100%"
                    height="315"
                    src={youtubeUrl}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
            ) : (
                <img className="border" src={thumbUrl} title="" alt="Thumbnail" />
            )}
          </div>
           <div className="col-lg-5 pt-4 pt-lg-0">
            {title && <h4>{parser(title)}</h4>}
            {description && <p>{parser(description)}</p>}

          </div>
        </div>
      </div>
    </div>
  );
}
